import React, { useState, useEffect } from 'react';
import { getPublicImagePath } from '@nutastic/nutastic-react-app';
import { ReactSVG } from 'react-svg';
import classnames from 'classnames';

const AppLoading = () => {
    const [addOnClasses, setAddOnClasses] = useState('loading-page--alternate');
    const componentClass = 'loading-page';
    const classes = classnames(componentClass, addOnClasses);

    useEffect(() => {
        setTimeout(() => setAddOnClasses(''), 1500);
    }, []);

    return <main className="appIsLoading">
        <div className={classes}>
            <section className={`${componentClass}__banner`}>
                <div className="overlay" />
                <div className="container h-100">
                    <div className={`${componentClass}__subtitle isCursive animated zoomIn delay-1s`}>timeless love</div>
                    <h1 className={`${componentClass}__title-header animated fadeInUp`}>Chelsi &amp; Spencer</h1>
                    <div className={`${componentClass}__subtitle hasBars`}>02.04.23</div>
                </div>
            </section>
        </div>
        <span className="animated zoomIn delay-1s">
            <i className="ion-ios-heart-empty animated zoomOut delay-2s" />
        </span>
    </main>;
};

export default AppLoading;
